import {isPlayerFaction} from "../../factions/isPlayerFaction";
import {FACTIONS} from "../../../constants/factions";
import {BEASTMEN_WIN_POINTS_BONUS_ON_KILL} from "../../../configs/factions/beastmen";
import {GIANTS_UNIT_WIN_POINTS} from "../../../configs/factions/giants";

export const calcWinPointsForKill = (killerPlayer, killedUnitConfig, killedUnitFactionId) => {
  // Великаны стоят игроку, уничтожившему их, больше очков победы (см.
  // GIANTS_UNIT_WIN_POINTS) - статический killedUnitConfig.winPoints фракцию
  // убитого отряда не учитывает
  let winPoints = killedUnitFactionId === FACTIONS.GIANTS
    ? GIANTS_UNIT_WIN_POINTS
    : killedUnitConfig.winPoints;

  if (isPlayerFaction(killerPlayer, FACTIONS.BEASTMEN)) {
    winPoints += BEASTMEN_WIN_POINTS_BONUS_ON_KILL;
  }

  return winPoints;
}